export default __webpack_public_path__ + "static/media/underline.97c4b116.svg";